/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_App_Feature_RecoveryInputs */

const en_price_page_app_feature_recovery = /** @type {(inputs: Price_Page_App_Feature_RecoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muscle recovery, muscle by muscle`)
};

const pl_price_page_app_feature_recovery = /** @type {(inputs: Price_Page_App_Feature_RecoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regeneracja mięśni partia po partii`)
};

/**
* | output |
* | --- |
* | "Muscle recovery, muscle by muscle" |
*
* @param {Price_Page_App_Feature_RecoveryInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_app_feature_recovery = /** @type {((inputs?: Price_Page_App_Feature_RecoveryInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_App_Feature_RecoveryInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_app_feature_recovery(inputs)
	return en_price_page_app_feature_recovery(inputs)
});